<template>
  <div class="p-item-carousel-group">
    <template v-if="showHistories">
      <div class="p-item-carousel-group__carousel__wrap">
        <h2 class="p-item-carousel-group__carousel__heading">閲覧履歴</h2>
        <ItemCarousel
          :item-list="histories"
          carousel-name="histories"
          class="p-item-carousel-group__carousel"
        ></ItemCarousel>

        <div class="p-item-carousel-group__button">
          <ButtonMain tag="a" href="/browser-history/" kind="secondary"
            >もっと見る</ButtonMain
          >
        </div>
      </div>
    </template>

    <template v-if="showRecommendations">
      <div class="p-item-carousel-group__carousel__wrap">
        <h2 class="p-item-carousel-group__carousel__heading">おすすめ</h2>
        <ItemCarousel
          :item-list="recommendations"
          carousel-name="recommendations"
          class="p-item-carousel-group__carousel"
        ></ItemCarousel>
        <div class="p-item-carousel-group__button">
          <ButtonMain tag="a" href="/product-list/" kind="secondary">
            もっと見る
          </ButtonMain>
        </div>
      </div>
    </template>

    <template v-if="showFavorites">
      <div class="p-item-carousel-group__carousel__wrap">
        <h2 class="p-item-carousel-group__carousel__heading">お気に入り</h2>
        <ItemCarousel
          :item-list="favorites"
          carousel-name="favorites"
          class="p-item-carousel-group__carousel"
        ></ItemCarousel>

        <div class="p-item-carousel-group__button">
          <ButtonMain tag="a" href="/favorites" kind="secondary"
            >もっと見る</ButtonMain
          >
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import ItemCarousel from "@/general/components/organisms/ItemCarousel.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";

import { mapState, mapActions } from "vuex";
import { Options, Vue } from 'vue-class-component';
import items from "@/general/store/modules/items";
import {
  browserHistory,
  getFavorites,
  getProductList
} from "@/general/store/api";
import ProductList from "../pages/ProductList.vue";

@Options({
  props: {
    histories: { type: Array, required: true, default: false },
    recommendations: { type: Array, required: true, default: false },
    favorites: { type: Array, required: true, default: false }
  },
  components: {
    ItemCarousel,
    ButtonMain
  }
})
export default class ItemCarouselGroup extends Vue {
  histories!: any;
  recommendations!: any;
  favorites!: any;

  get showHistories() {
    return this.histories.length > 0;
  }

  get showRecommendations() {
    return this.recommendations.length > 0;
  }

  get showFavorites() {
    return this.favorites.length > 0;
  }
}
</script>

<style lang="scss" scoped>
.p-item-carousel-group {
  &__button {
    margin-top: rem(40);
    display: flex;
    justify-content: center;

    @include sp {
      margin-top: rem(32);
    }
  }

  &__carousel {
    margin-top: rem(24);

    @include sp {
      margin-top: rem(8);
    }

    &__wrap {
      padding: rem(24) 0 rem(54) 0;
      border-top: px(1) solid $common-gray-border;

      @include sp {
        padding: rem(32) 0;
      }
    }
    &__heading {
      font-size: rem(20);
      font-weight: bold;
      line-height: (27/20);
    }
  }
}
</style>
